/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hostname: NonNullable<unknown> }} Browser_Ext_Home_Limited_Compatibility_DescriptionInputs */

const en_browser_ext_home_limited_compatibility_description = /** @type {(inputs: Browser_Ext_Home_Limited_Compatibility_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} has limited compatibility with our extension. Some features might not work correctly on this domain.`)
};

const es_browser_ext_home_limited_compatibility_description = /** @type {(inputs: Browser_Ext_Home_Limited_Compatibility_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} tiene compatibilidad limitada con nuestra extensión. Algunas funciones podrían no funcionar correctamente en este dominio.`)
};

/**
* | output |
* | --- |
* | "{hostname} has limited compatibility with our extension. Some features might not work correctly on this domain." |
*
* @param {Browser_Ext_Home_Limited_Compatibility_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const browser_ext_home_limited_compatibility_description = /** @type {((inputs: Browser_Ext_Home_Limited_Compatibility_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browser_Ext_Home_Limited_Compatibility_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_browser_ext_home_limited_compatibility_description(inputs)
	return en_browser_ext_home_limited_compatibility_description(inputs)
});